import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BillersState } from './state';
import { BILLERS_BENEFICIARIES_FEATURE_KEY, BILLERS_FEATURE_KEY, PENDING_BILLS_FEATURE_KEY } from './reducers';

export const selectBillersState = createFeatureSelector<BillersState>(BILLERS_FEATURE_KEY);
export const selectBillerBeneficiariesState = createFeatureSelector<any>(BILLERS_BENEFICIARIES_FEATURE_KEY);
export const selectPendingBillsState = createFeatureSelector<any>(PENDING_BILLS_FEATURE_KEY);

export const selectAllBillers = createSelector(
  selectBillersState,
  (state: any) => state?.billers
);

export const selectBillerBeneficiaries = createSelector(
  selectBillerBeneficiariesState,
  (state: any) => state?.billerBeneficiaries
);

// export const selectPendingBills = createSelector(
//   selectPendingBillsState,
//   (state: any) => state?.pendingBills
// );

export const selectPendingBills = createSelector(
  selectPendingBillsState,
  (state: any) => ({
    pendingBills: state?.pendingBills,
    responseMessage: state?.responseMessage
  })
);
